import { render, staticRenderFns } from "./EditarPerfil.vue?vue&type=template&id=292f081f&scoped=true&"
import script from "./EditarPerfil.vue?vue&type=script&lang=js&"
export * from "./EditarPerfil.vue?vue&type=script&lang=js&"
import style0 from "./EditarPerfil.vue?vue&type=style&index=0&id=292f081f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f081f",
  null
  
)

export default component.exports